import { notification as notifications } from "antd";

export default notifications;
